<template>
    <!-- Start Main Content -->
    <div v-show="!isBarcodePrint" class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Attendance Report</h2>
        </div>

  
        <!-- Filter Form -->
        <div class="card p-4 mb-4">
            <form @submit.prevent="filterAttendances">
                <div class="flex items-center space-x-4">
                  <div>
                    <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
                    <input type="date" id="startDate" v-model="startDate" class="p-2 border border-gray-300 rounded" />
                  </div>
                  <div class="ml-4">
                    <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
                    <input type="date" id="endDate" v-model="endDate" class="p-2 border border-gray-300 rounded" />
                  </div>
                  <div class="ml-4 mt-5">
                    <select  class="form-input" v-model="selectedEmployeeId">
                        <option v-for="(item, index) in empParentList" :key="index" :value="item.id">
                            {{ item.name }}
                        </option>
                        </select>
                  </div>
                  <div class="mt-5 ml-3">
                    <button type="submit" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm" @click="filter_dates()">Filter</button>
                  </div>
                </div>
              </form>
        </div>
        <div class="performance-container">
            <!-- Best performance box -->
            <div class="performance-box Best1">
              <p>Best</p>
            </div>
            
            <!-- Good performance box -->
            <div class="performance-box Good1">
              <p>Good</p>
            </div>
            
            <!-- Average performance box -->
            <div class="performance-box Average1">
              <p>Average</p>
            </div>
          </div>
        <div class="grid grid-cols-12">
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">

                        <table id="basicDataTable" class="datatable min-w-full bg-white divide-y divide-gray-200">
                          <thead class="bg-gray-50">  
                              <tr>
                                <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" >Employee Name</th>
                                <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"  v-for="day in report_dates" :key="day">{{ day }}</th>
                                <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" >Salary</th>
                                <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" >Days</th>
                                <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" >Amount</th>
                              </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                              <tr v-for="(item, index) in attendanceReport" :key="item.id">
                                <td>{{ item.empname }}</td>
                                <template  v-for="(day, index) in item.datahere" :key="index">
                                    <td class="px-6 py-4 whitespace-nowrap">
                                           <div v-if="day.status=='p'">✓ <span :class="getPerformanceClass(day.performance)">
                                            {{ day.plot_name }}
                                          </span>
                                          <span :style="{ color: day.is_paid_color }">
                                            - {{ day.is_paid }}
                                        </span>
                                        </div>
                                            <div v-else>✗</div>
                                        </td>
                                </template>
                                
                                <td class="px-6 py-4 whitespace-nowrap"><input type="text" class="salary_input" v-model="item.salary"></td>
                                <td class="px-6 py-4 whitespace-nowrap">{{ item.presenty }}</td> 
                                <td class="px-6 py-4 whitespace-nowrap">{{ parseInt(item.salary) * parseInt(item.presenty)}}</td>
                              </tr>
                            </tbody>
                          </table>
                         <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-50">  
                                <tr>
                                    <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"   >Label</th>
                                    <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"   >Count</th>
                                    <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"   >Rate</th>
                                    <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"   >Amount</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr>
                                    <td class="px-6 py-4 whitespace-nowrap">Male</td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <input 
                                            type="number" 
                                            v-model="totalMaleCount" 
                                            class="w-full border px-2 py-1 form-input" 
                                        >
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <input 
                                            type="number" 
                                            v-model.number="maleRate" 
                                            class="w-full border px-2 py-1 form-input" 
                                        >
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <span>{{ (totalMaleCount * maleRate).toFixed(2) }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-6 py-4 whitespace-nowrap">Female</td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <input 
                                            type="number" 
                                            v-model="totalFemaleCount" 
                                            class="w-full border px-2 py-1 form-input" 
                                        >
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <input 
                                            type="number" 
                                            v-model.number="femaleRate" 
                                            class="w-full border px-2 py-1 form-input" 
                                        >
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <span>{{ (totalFemaleCount * femaleRate).toFixed(2) }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-6 py-4 whitespace-nowrap">Gadi Bhade</td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <input 
                                            type="number" 
                                            :value="totalMaleCount + totalFemaleCount" 
                                            class="w-full border px-2 py-1 form-input" 
                                            readonly
                                        >
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <input 
                                            type="number" 
                                            v-model.number="gadiBhadeRate" 
                                            class="w-full border px-2 py-1 form-input" 
                                        >
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <span>{{ ((totalMaleCount + totalFemaleCount) * gadiBhadeRate).toFixed(2) }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-6 py-4 whitespace-nowrap"><b>Total</b></td>
                                    <td class="px-6 py-4 whitespace-nowrap"></td>
                                    <td class="px-6 py-4 whitespace-nowrap"></td>
                                    <td class="px-6 py-4 whitespace-nowrap"><b>{{ totalAmount }}</b></td>
                                </tr>
                            </tbody>
                        </table>
                        
                           <!-- <table id="basicDataTable" class="min-w-full bg-white divide-y divide-gray-200">
                            <thead>
                              
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr>
                                    <td>  
                                        Male  </td>
                                    <td> <input type="number" v-model="totalMaleCount"  class="w-full border px-2 py-1" ></td>
                                    <td> <input type="number" v-model="rate" class="w-full border px-2 py-1" @input="updateAmount(totalMaleCount,rate)"></td>
                                </tr>
                                <tr>
                                    <td>  
                                        Female </td>
                                    <td> <input type="number" v-model="totalFemaleCount" class="w-full border px-2 py-1"></td>
                                    <td> <input type="number" v-model="rate" class="w-full border px-2 py-1" @input="updateAmount(totalFemaleCount,rate)"></td>
                                </tr>
                                <tr>
                                    <td>  
                                        Gadi Bhade </td>
                                    <td> <input type="number" :value="totalMaleCount + totalFemaleCount" class="w-full border px-2 py-1" ></td>
                                    <td> <input type="number" v-model="f" class="w-full border px-2 py-1" @input="updateAmount(index)"></td>
                                </tr>
                                <tr>
                                    <td>{{ totalMaleCount }}</td>
                                    <td>{{ totalFemaleCount }}</td>
                                    <td>{{ totalMaleCount+totalFemaleCount }}</td>
                                </tr>
                                
                            </tbody>
                            <tfoot>
                                
                            </tfoot>
                        </table>     -->

                        
                          
                        
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
        </div>
        <button type="submit" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm" @click="saveSalarySlip">Save</button>
    </div>
    <!-- End Main Content -->
    
    <!-- Start Delete Modal -->
   
    <!-- End Delete Modal -->
</template>
<style scoped>
    .salary_input{
        padding: 5px;
        width: 70px;
    }
    .plotname{
        font-size: x-small;
    font-weight: 200;
    background: yellow;
    padding: 0px 2px;
    border-radius: 10px;
    }

    .performance-container {
      display: flex;
      gap: 20px;
    }
    .performance-box {
      padding: 1px;
      border-radius: 8px;
      color: white;
      text-align: center;
      font-weight: bold;
      width: 80px;
    }
    
    .Best1 {
      background-color: green;
    }
    .Good1 {
      background-color: blue;
    }
    .Average1 {
      background-color: orange;
    }

    .best {
  color: green;
}
.good {
  color: blue;
}
.average {
  color: orange;
}
</style>
<script>
import axios from 'axios'; 

export default {
    name: 'AddProduct',
    components: { 
    },
    mounted() {
        if(this.$route.query.filterdate){
            this.getBasicsFilterData(this.$route.query.filterdate,this.$route.query.month);
        }
        else
            this.getBasics(); 
    },
    data() {
        return {
          
            totalMaleCount: 0,
            totalFemaleCount: 0,
            maleRate: 0,
            femaleRate: 0,
            
            gadiBhadeRate: 0,
                    products: [
                { label: 'एकूण वाया', quantity: 88, rate: 350, amount: 0 },
                { label: 'एकूण गाडी', quantity: 13, rate: 400, amount: 0 },
            ],
            empParentList: [],
            selectedEmployeeId: null,
            filteredAttendanceList: [],
            startDate: '',
            endDate: '', 
            datatable: null,
            productss: { iddate: '' },
            employees: { empname: '', emprole: '0', isMainAdmin: 0 },
            attendanceReport:[],
            report_dates:[]
        }
    },
    computed: {
        
        totalAmount() {
            //  return 0;
            return (
                (this.totalMaleCount * this.maleRate) +
                (this.totalFemaleCount * this.femaleRate) + 
                ((this.totalMaleCount + this.totalFemaleCount) * this.gadiBhadeRate)
            );
        },
        amounts() {
            return 0;
    //   return this.filteredAttendanceList.map(item => {
    //     const presentDays = this.getPresentDaysInWeek(item);
    //     return {
    //       ...item,
    //       amount: this.calculateAmount(item.salary, presentDays).toFixed(2), // Calculate amount
    //       presentDays // Include present days for further use
    //     };
    //   });
    },
    },
    methods: {
        getPerformanceClass(performance) {
              if (performance == "3") return 'best';
              if (performance == "2") return 'good';
              return 'average'; 
            },
        saveSalarySlip() {
        const salarySlipData = {
            parent_id: this.selectedEmployeeId,  
            from_date: this.startDate,  
            to_date: this.endDate,  
            total_male: this.totalMaleCount,  
            male_amt: this.totalMaleCount * this.maleRate,
            total_female: this.totalFemaleCount, 
            female_amt: this.totalFemaleCount * this.femaleRate,
            gadi_bhade: this.totalMaleCount + this.totalFemaleCount,
            gadi_rate: this.gadiBhadeRate,  
            amount: this.totalAmount  
        }
        console.log(salarySlipData);
        axios.post('saveSalarySlip', salarySlipData)
            .then(response => {
                if(response.data.status == 'success')
                // var salary_id = response.data.salary_id;
                // this.savePresentEmployeesDetails(salary_id);
                this.$swal(response.data.message);
                // console.log(response.data);
            })
            .catch(error => {
                console.error('Error saving salary slip:', error);
            });
    },
    
          
        async getBasics() {
            var self = this;
            axios.post('getattendancereport').then(function (response) {
                self.empList = response.data.list;  // Store the full employee attendance list
                self.empParentList = response.data.emp_parent_list;  // Store the employee list for dropdown
                self.filteredAttendanceList = self.empList;   // Store the employee list for dropdown
                
                self.attendanceReport =  response.data.attendanceReport.att;   
                self.report_dates =  response.data.attendanceReport.dates; 
                
                
                self.startDate = response.data.fromdate;   
                self.endDate = response.data.todate; 
                
                
                self.totalMaleCount = response.data.attendanceReport.maleCounter; 
                self.totalFemaleCount = response.data.attendanceReport.femaleCounter; 
                
                console.log(self.filteredAttendanceList);
            })
            .then(() => {
                
            });
        },
        async filter_dates() {
            var self = this;
            axios.post('getattendancereport',{fromDate:this.startDate,toDate:this.endDate,parent_id: this.selectedEmployeeId}).then(function (response) {
                self.empList = response.data.list;  // Store the full employee attendance list
                self.empParentList = response.data.emp_parent_list;  // Store the employee list for dropdown
                self.filteredAttendanceList = self.empList;   // Store the employee list for dropdown
                 self.attendanceReport =  response.data.attendanceReport.att;   
                
                self.report_dates =  response.data.attendanceReport.dates; 
                
                
                self.startDate = response.data.fromdate;   
                self.endDate = response.data.todate; 
                
             
                self.totalMaleCount = response.data.attendanceReport.maleCounter; 
                self.totalFemaleCount = response.data.attendanceReport.femaleCounter; 
                
                  
            })
            .then(() => {
               
                
               
            });
        },

        async getBasicsFilterData(day,month) {
            var self = this;
            axios.post('getattendancereport_filterdata',{day:day,month:month}).then(function (response) {
                self.empList = response.data.list;  // Store the full employee attendance list
                self.empParentList = response.data.emp_parent_list;  // Store the employee list for dropdown
                self.filteredAttendanceList = self.empList;   // Store the employee list for dropdown
                 self.attendanceReport =  response.data.attendanceReport.att;   
                
                self.report_dates =  response.data.attendanceReport.dates; 
                
                
                self.startDate = response.data.fromdate;   
                self.endDate = response.data.todate; 
                
             
                self.totalMaleCount = response.data.attendanceReport.maleCounter; 
                self.totalFemaleCount = response.data.attendanceReport.femaleCounter; 
                
                  
            })
            .then(() => {
               
                
               
            });
        },
 
    }
}
</script>
